import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";
import { formatDateForApi } from "api/utils/formatDateForApi";
import { MeetingCalendarEvent } from "components/MeetingCalendar/MeetingCalendar";

type Params = {
	meetingId: string;
	reschedulerUid: string;
	message?: string;
	newSessionEvent: Pick<MeetingCalendarEvent, "start" | "end">;
};

export const sendMeetingRescheduleRequest = makeSubmitData<Params>(
	"meetingRescheduleRequest",
	undefined,
	({ newSessionEvent, ...rest }) => ({
		...rest,
		newSessionEvent: {
			startUTC: formatDateForApi(newSessionEvent.start),
			endJustBeforeUTC: formatDateForApi(newSessionEvent.end)
		}
	})
);
